module.exports = __webpack_public_path__ + "static/1-7513d25f96cf1deecbc6344f18916867.jpg";